import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BOOKING_API_URL,
});

// Module-level variable to store current appId
let currentAppId = null;

/**
 * Setter function called by JourneyContextProvider to inject appId
 */
export const setAppId = (appId) => {
  if (!appId) {
    console.warn(
      "appId is empty, will fall back to REACT_APP_DEFAULT_APP_ID",
      process.env.REACT_APP_DEFAULT_APP_ID
    );
  }
  currentAppId = appId;
};

/**
 * Request interceptor: automatically adds appId to query params for all requests
 */
axiosInstance.interceptors.request.use((config) => {
  // Determine which appId to use
  const appIdToUse = currentAppId || process.env.REACT_APP_DEFAULT_APP_ID;

  // Only add to query params if appId exists
  if (appIdToUse) {
    config.params = {
      ...config.params, // Preserve any existing params
      appId: appIdToUse,
    };
  }

  return config;
});

export default axiosInstance;
